var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ActionDialog',_vm._g(_vm._b({attrs:{"label":"Вы действительно хотите отменить отправку проекта в Минздрав и вернуть его в работу ?","labelBtnClose":"ОТМЕНА","labelBtnAction":"ВЕРНУТЬ"}},'ActionDialog',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }